import React, { PropTypes } from 'react';
import VideoOnDemandEditForm from '../VideoOnDemandEditForm';
import LoadingSpinner from '../../../LoadingSpinner';

class StreamEdit extends React.Component {
  static propTypes = {
    model: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetch(this.props.params.id);
  }

  render() {
    let { loading, ...rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        <VideoOnDemandEditForm label="Edit Video on Demand" {...rest} />
      </LoadingSpinner>
    );
  }
}

export default StreamEdit;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/VideoOnDemandEdit/VideoOnDemandEdit.jsx